// klaviyo-geo-popin.js

class KlaviyoGeoPopin extends HTMLElement {
    constructor() {
        super();
        this.countryCode = null;
        this.countryFormMap = {
            FR: ['FR', 'MC'],
            ES: ['ES'],
            UK: ['UK', 'GB', 'IR'],
            IT: ['IT'],
            DE: ['DE'],
            US: ['US', 'CA'],
            EU: ['AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'GR', 'HR',
                'HU', 'IE', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO',
                'SE', 'SI', 'SK']
        };
    }
    trigger = document.getElementById('klaviyo-popin--trigger');

    connectedCallback() {
        this.trigger.addEventListener('click', event => {
            event.preventDefault();
            this._handleTriggerClick();
        })
    }

    _handleTriggerClick() {

        const formID = this._getKlaviyoFormIdByCountry(this.getCountry())
        this._openKlaviyoForm(formID)

    }


    _getKlaviyoFormIdByCountry(countryCode) {
        switch(countryCode) {
            case 'FR':
                return 'Rs8hue'; // Reemplaza con el ID real del formulario Klaviyo para Francia
            case 'ES':
                return 'VTjezk'; // Reemplaza con el ID real del formulario Klaviyo para España
            case 'UK':
                return 'WHCxTH'; // Reemplaza con el ID real del formulario Klaviyo para Reino Unido
            case 'IT':
                return 'YyZVKx'; // Reemplaza con el ID real del formulario Klaviyo para Italia
            case 'DE':
                return 'VXAJRi'; // Reemplaza con el ID real del formulario Klaviyo para Alemania
            case 'US':
                return 'ST8fS2'; // Reemplaza con el ID real del formulario Klaviyo para Estados Unidos
            case 'EU':
                return 'Yx7rCZ'; // Reemplaza con el ID real del formulario Klaviyo para la Unión Europea
            default:
                return 'Yx7rCZ';
        }
    }
    fetchGeo () {
        fetch("https://ipapi.co/json/")
            .then(res => res.json())
            .then(data => {
                if (data && data.country) {
                    const cacheData = {
                        country: data.country,
                        timestamp: Date.now()
                    };
                    window.localStorage.setItem(this.geoIpCacheKey, JSON.stringify(cacheData));
                    this.countryCode = data.country || 'FR'; // Default to US if no country found
                 }
            })
            .catch(error => {
            });
    }

    getCountry () {
        if (this.countryCode) {
            return this.countryCode;
        }
        const cache = window.localStorage.getItem(this.geoIpCacheKey);
        if (cache) {
            try {
                const parsedCache = JSON.parse(cache);
                const now = Date.now();
                if ((now - parsedCache.timestamp) > this.geoIpCacheTTL) {
                    this.fetchGeo();
                }
                this.countryCode = parsedCache.country || 'FR'; // Default to US if no country found
            } catch (e) {
                this.fetchGeo();
            }
        } else {
            this.fetchGeo();
        }
        return this.countryCode; // Default to US if no country found
    }
    _openKlaviyoForm(formId) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
    }
}

// Registrar el custom element
if (!customElements.get('klaviyo-geo-popin')) {
    customElements.define('klaviyo-geo-popin', KlaviyoGeoPopin);
}